export default __webpack_public_path__ + "static/media/icon_pinterest.a1ed37e5.svg";